module.exports = __webpack_public_path__ + "img/vmc_aniv15_24Aug2021.77b56ca4.jpg";